import { useState } from "react";
import { toast } from "sonner";
import { Tag, Loader2, X, Gift } from "lucide-react";
import { Input } from "./ui/input";
import { Button } from "./ui/button";
import { post, verifyLicense, webOrigin } from "../lib/pro";

export const PromoBox = ({ promo, setPromo }) => {
  const [code, setCode] = useState("");
  const [busy, setBusy] = useState(false);
  const apply = async (e) => {
    e.preventDefault();
    setBusy(true);
    try { const r = await post("/api/promo/check", { code }); setPromo(r); toast.success(r.price ? `Code applied: S$${r.price.toFixed(2)}` : "Code applied: free licence"); }
    catch (x) { toast.error(x.message); }
    setBusy(false);
  };
  if (promo) return (
    <div className="flex items-center gap-2 rounded-lg border border-emerald-500/40 bg-emerald-500/10 px-3 py-2 text-sm" data-testid="promo-applied">
      <Tag className="h-4 w-4 text-emerald-600" /><span className="font-mono font-semibold">{promo.code}</span>
      <span className="flex-1 text-emerald-700 dark:text-emerald-400">−S${promo.discount.toFixed(2)}</span>
      <button type="button" onClick={() => setPromo(null)} aria-label="Remove promo code" data-testid="promo-remove-btn"><X className="h-4 w-4 text-muted-foreground" /></button>
    </div>
  );
  return (
    <form onSubmit={apply} className="flex gap-2">
      <Input value={code} onChange={(e) => setCode(e.target.value.toUpperCase())} placeholder="Promo code" maxLength={20} className="font-mono text-xs" data-testid="promo-code-input" />
      <Button type="submit" variant="outline" disabled={code.length < 3 || busy} data-testid="promo-apply-btn">{busy ? <Loader2 className="h-4 w-4 animate-spin" /> : "Apply"}</Button>
    </form>
  );
};

export const FreeRedeem = ({ promo, onDone }) => {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const redeem = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const r = await post("/api/promo/redeem", { code: promo.code, email, origin_url: webOrigin() });
      if (r.license_key && (await verifyLicense(r.license_key))) onDone();
    } catch (x) { toast.error(x.message); }
    setBusy(false);
  };
  return (
    <form onSubmit={redeem} className="space-y-2" data-testid="promo-free-form">
      <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email for your licence key (optional)" data-testid="promo-free-email-input" />
      <Button type="submit" className="w-full" disabled={busy} data-testid="promo-redeem-btn">{busy ? <Loader2 className="h-4 w-4 mr-2 animate-spin" /> : <Gift className="h-4 w-4 mr-2" />}Get my free Pro licence</Button>
    </form>
  );
};
